"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const common_components_1 = require("@yandex-int/pythia-libs/lib/common-components");
const markdown_renderer_1 = __importDefault(require("@yandex-int/pythia-libs/lib/markdown-renderer"));
const actions_1 = require("src/redux/actions");
const attachment_1 = __importDefault(require("../attachment"));
const attachment_with_timer_1 = __importDefault(require("../attachment-with-timer"));
const container_with_timer_1 = __importDefault(require("../container-with-timer"));
const types_1 = require("../types");
const widget_markup_styles_1 = __importDefault(require("./widget-markup.styles"));
// @ts-expect-error TS(2345): Argument of type 'readonly ["blockquote", "fence",... Remove this comment to see the full error message
const mdRender = (0, markdown_renderer_1.default)(common_components_1.MARKDOWN_OPTIONS);
const b = b_1.default.with('widget-markup');
// eslint-disable-next-line max-statements, complexity
function Markup(props) {
    const i18n = (0, i18n_1.default)(['attach', 'text']);
    const i18nLabels = (0, i18n_1.default)(['labels']);
    const curtainTextDesc = {
        [types_1.TimeLimitType.NOT_MORE]: i18n(['notMore']),
        [types_1.TimeLimitType.NOT_LESS]: i18n(['notLess'])
    };
    const { attachment, hasTimeLimit, id, label = '', theme = 'default', timeLimit, timeLimitType = types_1.TimeLimitType.NOT_MORE, visible } = props;
    const text = mdRender(label);
    const [status, setStatus] = (0, react_2.useState)(types_1.AttachmentStatus.Initial);
    const Attach = hasTimeLimit ? attachment_with_timer_1.default : attachment_1.default;
    const wrapper = (0, react_2.useRef)(null);
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleStatus = value => {
        setStatus(value);
        if (value === types_1.AttachmentStatus.End) {
            dispatch((0, actions_1.widgetCompleted)(id));
        }
    };
    const onShow = () => {
        handleStatus(types_1.AttachmentStatus.Playing);
    };
    const collapseView = () => {
        if (wrapper.current) {
            const element = wrapper.current;
            const elementHeight = element.scrollHeight;
            const elementTransition = element.style.transition;
            element.style.transition = '';
            requestAnimationFrame(() => {
                element.style.height = `${elementHeight}px`;
                element.style.transition = elementTransition;
                requestAnimationFrame(() => {
                    element.style.overflow = 'hidden';
                    element.style.height = `${0}px`;
                });
            });
        }
    };
    const attachmentProps = {
        handleStatus,
        hasTimeLimit,
        collapseView,
        onShow,
        status,
        timeLimit,
        timeLimitType
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: wrapper, className: b({ theme, ended: status === types_1.AttachmentStatus.End, hidden: !visible }) }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: (0, widget_markup_styles_1.default)() }), visible === false && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('bubble') }, { children: i18n(['widgetHidden']) })), attachment && attachment.position === 'top' && ((0, jsx_runtime_1.jsx)(Attach, Object.assign({ value: attachment }, attachmentProps))), label && (attachment || !hasTimeLimit) && ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: text }, className: b('label') })), !attachment && hasTimeLimit && ((0, jsx_runtime_1.jsx)(container_with_timer_1.default, Object.assign({}, attachmentProps, { tpl: curtainTextDesc[timeLimitType] }, { children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: text }, className: b('text') }) }))), attachment && attachment.position === 'bottom' && ((0, jsx_runtime_1.jsx)(Attach, Object.assign({ value: attachment }, attachmentProps)))] })));
}
exports.default = Markup;
